import { keyframes, forwardRef, useStyleConfig, omitThemingProps, chakra } from '@chakra-ui/system';
import { cx, __DEV__ } from '@chakra-ui/utils';
import { VisuallyHidden } from '@chakra-ui/visually-hidden';
import * as React from 'react';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var _excluded = ["label", "thickness", "speed", "emptyColor", "className"];
var spin = keyframes({
  "0%": {
    transform: "rotate(0deg)"
  },
  "100%": {
    transform: "rotate(360deg)"
  }
});

/**
 * Spinner is used to indicate the loading state of a page or a component,
 * It renders a `div` by default.
 *
 * @see Docs https://chakra-ui.com/spinner
 */
var Spinner = /*#__PURE__*/forwardRef(function (props, ref) {
  var styles = useStyleConfig("Spinner", props);
  var _omitThemingProps = omitThemingProps(props),
    _omitThemingProps$lab = _omitThemingProps.label,
    label = _omitThemingProps$lab === void 0 ? "Loading..." : _omitThemingProps$lab,
    _omitThemingProps$thi = _omitThemingProps.thickness,
    thickness = _omitThemingProps$thi === void 0 ? "2px" : _omitThemingProps$thi,
    _omitThemingProps$spe = _omitThemingProps.speed,
    speed = _omitThemingProps$spe === void 0 ? "0.45s" : _omitThemingProps$spe,
    _omitThemingProps$emp = _omitThemingProps.emptyColor,
    emptyColor = _omitThemingProps$emp === void 0 ? "transparent" : _omitThemingProps$emp,
    className = _omitThemingProps.className,
    rest = _objectWithoutPropertiesLoose(_omitThemingProps, _excluded);
  var _className = cx("chakra-spinner", className);
  var spinnerStyles = _extends({
    display: "inline-block",
    borderColor: "currentColor",
    borderStyle: "solid",
    borderRadius: "99999px",
    borderWidth: thickness,
    borderBottomColor: emptyColor,
    borderLeftColor: emptyColor,
    animation: spin + " " + speed + " linear infinite"
  }, styles);
  return /*#__PURE__*/React.createElement(chakra.div, _extends({
    ref: ref,
    __css: spinnerStyles,
    className: _className
  }, rest), label && /*#__PURE__*/React.createElement(VisuallyHidden, null, label));
});
if (__DEV__) {
  Spinner.displayName = "Spinner";
}
export { Spinner };